module.exports = __webpack_public_path__ + "media/images/riders/SAMUEL_GAZE-1be224fab0110fa399ac30cf03291bb1.png";